import { __rest } from "tslib";
import clsx from 'clsx';
import * as React from 'react';
import ChevronRightIcon from '@cmpkit/icon/lib/glyph/chevron-right';
import { Slot } from '@cmpkit/utils';
const Breadcrumb = React.forwardRef((_a, ref) => {
    var props = __rest(_a, []);
    return React.createElement("nav", Object.assign({ ref: ref, "aria-label": 'breadcrumb' }, props));
});
Breadcrumb.displayName = 'Breadcrumb';
const BreadcrumbList = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("ol", Object.assign({ ref: ref, className: clsx('flex flex-wrap items-center gap-1.5 break-words text-sm sm:gap-2.5', className) }, props)));
});
BreadcrumbList.displayName = 'BreadcrumbList';
const BreadcrumbItem = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("li", Object.assign({ ref: ref, className: clsx('inline-flex items-center gap-1.5', className) }, props)));
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
const BreadcrumbLink = React.forwardRef((_a, ref) => {
    var { asChild, className } = _a, props = __rest(_a, ["asChild", "className"]);
    const Comp = asChild ? Slot : 'a';
    return (React.createElement(Comp, Object.assign({ ref: ref, className: clsx(' text-muted no-underline transition-colors hover:text-foreground', className) }, props)));
});
BreadcrumbLink.displayName = 'BreadcrumbLink';
const BreadcrumbPage = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("span", Object.assign({ ref: ref, role: 'link', "aria-disabled": 'true', "aria-current": 'page', className: clsx('font-bold text-muted', className) }, props)));
});
BreadcrumbPage.displayName = 'BreadcrumbPage';
const BreadcrumbSeparator = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (React.createElement("li", Object.assign({ role: 'presentation', "aria-hidden": 'true', className: clsx('inline-flex items-center text-muted [&>svg]:size-3.5', className) }, props), children !== null && children !== void 0 ? children : React.createElement(ChevronRightIcon, null)));
};
BreadcrumbSeparator.displayName = 'BreadcrumbSeparator';
const BreadcrumbEllipsis = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("span", Object.assign({ role: 'presentation', "aria-hidden": 'true', className: clsx('flex items-center justify-center', className) }, props),
        React.createElement("span", null, "..."),
        React.createElement("span", { className: 'sr-only' }, "More")));
};
BreadcrumbEllipsis.displayName = 'BreadcrumbElipssis';
export { Breadcrumb, BreadcrumbList, BreadcrumbItem, BreadcrumbLink, BreadcrumbPage, BreadcrumbSeparator, BreadcrumbEllipsis, };
//# sourceMappingURL=index.js.map